<script setup lang="ts">
import { IconEye, IconEyeClosed, IconLock } from '@tabler/icons-vue'

const props = defineProps(['modelValue', 'mode'])
defineEmits(['update:modelValue'])
const { t } = useI18n()

const typePassword = ref('password')

function showPassword() {
  if (typePassword.value === 'password') {
    typePassword.value = 'text'
  } else {
    typePassword.value = 'password'
  }
}

const placeholder = computed(() => {
  if (props.mode === 'placeholder') return 'Password'
  return ''
})
</script>
<template>
  <div>
    <label class="mb-2" v-if="mode !== 'placeholder'">{{ t('Password') }}</label>
    <CInputGroup>
      <CInputGroupText>
        <IconLock stroke-width="1" />
      </CInputGroupText>
      <CFormInput
        :type="typePassword"
        name="password"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        autocomplete="off"
        :placeholder="t(placeholder)"
      />
      <CButton color="secondary" @click="showPassword" class="shadow-none">
        <IconEye v-if="typePassword === 'text'" stroke-width="1" />
        <IconEyeClosed v-else stroke-width="1" />
      </CButton>
    </CInputGroup>
  </div>
</template>
